<template>
  <div class="arc-sec">
    <div class="arc-grid">
      <div class="arc-ro">
        <span class="lbl">{{ $t('ARC_MGMT.GENERAL.PIC') }}</span><b>{{ journey.pic }}</b>
      </div>
      <div class="arc-ro">
        <span class="lbl">{{ $t('ARC_MGMT.GENERAL.START') }}</span><b>{{ journey.data_inicio }}</b>
      </div>
      <div class="arc-ro">
        <span class="lbl">{{ $t('ARC_MGMT.GENERAL.CYCLE') }}</span><b>{{ journey.ciclo }}</b>
      </div>
      <div class="arc-ro">
        <span class="lbl">{{ $t('ARC_MGMT.GENERAL.CONSULTANT') }}</span>
        <b>{{ journey.consultor ? journey.consultor.email : '—' }}</b>
      </div>
      <div class="arc-ro">
        <span class="lbl">{{ $t('ARC_MGMT.GENERAL.INVESTMENT') }}</span>
        <b>{{ formatMoney(journey.investimento_mensal) }}</b>
      </div>
    </div>

    <form class="arc-form" @submit.prevent="save">
      <label>
        {{ $t('ARC_MGMT.GENERAL.STATUS') }}
        <select v-model="form.status">
          <option value="ativa">Ativa</option>
          <option value="pausada">Pausada</option>
          <option value="concluida">Concluída</option>
          <option value="cancelada">Cancelada</option>
        </select>
      </label>
      <label v-if="form.status === 'pausada'">
        {{ $t('ARC_MGMT.GENERAL.FROZEN_MONTH') }}
        <input v-model.number="form.mes_congelado" type="number" min="1" max="12" />
      </label>
      <label>
        {{ $t('ARC_MGMT.GENERAL.MONTH_OVERRIDE') }}
        <input v-model.number="form.mes_atual_override" type="number" min="1" max="12" placeholder="—" />
      </label>
      <label class="arc-full">
        {{ $t('ARC_MGMT.GENERAL.FOCUS') }}
        <input v-model="form.foco" type="text" />
      </label>
      <label class="arc-check">
        <input v-model="form.visivel_para_agentes" type="checkbox" />
        {{ $t('ARC_MGMT.GENERAL.VISIBLE_AGENTS') }}
      </label>

      <div class="arc-actions">
        <button type="submit" class="btn primary" :disabled="saving">{{ $t('ARC_MGMT.SAVE') }}</button>
        <button type="button" class="btn" @click="applyUpdates">{{ $t('ARC_MGMT.GENERAL.APPLY_TEMPLATE') }}</button>
        <button type="button" class="btn danger-ghost" @click="nextCycle">{{ $t('ARC_MGMT.GENERAL.NEXT_CYCLE') }}</button>
        <span v-if="feedback" class="arc-feedback">{{ feedback }}</span>
      </div>
    </form>
  </div>
</template>

<script>
import ArcAPI from 'dashboard/api/arc';

export default {
  props: { journey: { type: Object, default: () => ({}) } },
  data() {
    return { form: this.pick(), saving: false, feedback: '' };
  },
  watch: {
    journey() { this.form = this.pick(); },
  },
  methods: {
    pick() {
      const j = this.journey || {};
      return {
        status: j.status, mes_congelado: j.mes_congelado, mes_atual_override: j.mes_atual_override,
        foco: j.foco, visivel_para_agentes: j.visivel_para_agentes,
      };
    },
    formatMoney(v) {
      return 'R$ ' + Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
    },
    async save() {
      this.saving = true;
      try {
        await this.$store.dispatch('arc/updateJourney', this.form);
        this.flash(this.$t('ARC_MGMT.SAVED'));
        this.$emit('refresh');
      } finally {
        this.saving = false;
      }
    },
    async applyUpdates() {
      const { data } = await ArcAPI.applyTemplateUpdates();
      this.flash(this.$t('ARC_MGMT.GENERAL.APPLIED', {
        e: data.entregas, i: data.indicadores, c: data.conquistas,
      }));
      this.$emit('refresh');
    },
    async nextCycle() {
      // eslint-disable-next-line no-alert
      if (!window.confirm(this.$t('ARC_MGMT.GENERAL.NEXT_CYCLE_CONFIRM'))) return;
      await ArcAPI.nextCycle();
      this.flash(this.$t('ARC_MGMT.GENERAL.NEXT_CYCLE_DONE'));
      this.$emit('refresh');
    },
    flash(msg) {
      this.feedback = msg;
      setTimeout(() => { this.feedback = ''; }, 4000);
    },
  },
};
</script>

<style lang="scss" scoped>
.arc-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: var(--space-small); margin-bottom: var(--space-normal); }
.arc-ro { background: var(--s-25); border: 1px solid var(--s-100); border-radius: var(--border-radius-normal); padding: var(--space-small) var(--space-normal);
  .lbl { display: block; font-size: var(--font-size-mini); color: var(--s-500); } b { color: var(--s-800); } }
.arc-form { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: var(--space-normal); max-width: 900px;
  label { display: flex; flex-direction: column; gap: var(--space-smaller); font-size: var(--font-size-small); color: var(--s-700); }
  input[type='text'], input[type='number'], select { height: var(--space-large); border: 1px solid var(--s-200); border-radius: var(--border-radius-normal); padding: 0 var(--space-small); background: var(--white); color: var(--s-800); }
}
.arc-full { grid-column: 1 / -1; }
.arc-check { flex-direction: row !important; align-items: center; gap: var(--space-small); }
.arc-actions { grid-column: 1 / -1; display: flex; gap: var(--space-small); align-items: center; flex-wrap: wrap; }
.btn { height: var(--space-large); padding: 0 var(--space-normal); border-radius: var(--border-radius-normal); border: 1px solid var(--s-200); background: var(--white); color: var(--s-700); font-weight: var(--font-weight-medium); cursor: pointer; }
.btn.primary { background: var(--w-500); border-color: var(--w-500); color: var(--white); }
.btn.danger-ghost { border-color: var(--r-200); color: var(--r-500); }
.arc-feedback { color: var(--g-600); font-size: var(--font-size-small); }
</style>
